import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@/lib/api/client';
import { useTenantStore } from '@/stores/tenantStore';

import { type QuestionnaireDto, questionnaireDtoSchema } from '../schemas/questionnaireSchemas';
import { questionnaireKeys } from './questionnaireKeys';

interface CreateInput {
  name: string;
  description?: string | null;
}

export function useCreateQuestionnaire() {
  const qc = useQueryClient();
  const tenantId = useTenantStore((s) => s.tenantId);

  return useMutation({
    mutationFn: async (body: CreateInput): Promise<QuestionnaireDto> => {
      const raw = await apiClient
        .post(`api/v1/t/${tenantId}/questionnaires`, { json: body })
        .json();
      return questionnaireDtoSchema.parse(raw);
    },
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: questionnaireKeys.lists() });
    },
  });
}
